<template>
  <v-container>
    <div class="breadcrumb-wrap">
      <div class="container">
        <v-breadcrumbs :items="breadcrumbs"/>
      </div>
    </div>
    <div class="position">
      <div class="bg-white p-20">
        <div class="appeal-pg">
          <h3 class="title-pg">{{ $t('Статистика по обращениям граждан и организаций на Портал проектов НПА') }}</h3>
          <div class="appeal-filter">
              <div class="law-statistic-item">
                <div class="item-head">
                  <v-list-item
                    v-bind:key="y.transName"
                    v-for="y in years"
                    @click="statisticAppeal(y.transName)"
                    v-bind:class="{ active: yearActive[y.transName] }"
                  >
                    <v-list-item-title>{{ y.transName }}</v-list-item-title>
                  </v-list-item>
                </div>
            </div>
          </div>
          <div class="appeal-item">
            <h5>{{ $t('Таблица 1. Статистика обращений по месяцам') }}</h5>
            <div class="table-overflow">
              <table>
                <thead>
                <tr>
                  <td rowspan="2">
                    {{ $t('Месяц') }}
                  </td>
                  <td rowspan="2">
                    {{ $t('Кол-во обращений') }}
                  </td>
                  <td colspan="5">
                    {{ $t('Из них') }}
                  </td>
                  <td rowspan="2" v-for="status in statuses" :key="status.id">
                    {{ status.transName }}
                  </td>
                </tr>
                <tr>
                  <td v-for="type in types" :key="type.id">
                    {{ type.transName }}
                  </td>
                </tr>
                </thead>
                <tbody>
                <tr v-bind:key="key" v-for="(monthStatistic, key) in monthStatistics" v-bind:class="{ 'bg-gray': !monthStatistic.monthCome }">
                  <td>{{ monthStatistic.month }}</td>
                  <td>{{ monthStatistic.total }}</td>
                  <td>{{ monthStatistic.types['1'].count }}</td>
                  <td>{{ monthStatistic.types['3'].count }}</td>
                  <td>{{ monthStatistic.types['2'].count }}</td>
                  <td>{{ monthStatistic.types['4'].count }}</td>
                  <td>{{ monthStatistic.types['5'].count }}</td>
                  <td>{{ monthStatistic.statuses['2'].count }}</td>
                  <td>{{ monthStatistic.statuses['3'].count }}</td>
                  <td>{{ monthStatistic.statuses['4'].count }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="appeal-item">
            <h5>{{ $t('Таблица 2. Статистика обращений по разработчика проектов НПА на Портале проектов НПА') }}</h5>
            <div class="table-overflow">
              <table>
                <thead>
                <tr>
                  <td rowspan="2">
                    {{ $t('Наименования гос.органа') }}
                  </td>
                  <td rowspan="2">
                    {{ $t('Кол-во обращений') }}
                  </td>
                  <td colspan="5">
                    {{ $t('Из них') }}
                  </td>
                  <td rowspan="2" v-for="status in statuses" :key="status.id">
                    {{ status.transName }}
                  </td>
                </tr>
                <tr>
                  <td v-for="type in types" :key="type.id">
                    {{ type.transName }}
                  </td>
                </tr>
                </thead>
                <tbody>
                <tr v-bind:key="key" v-for="(developerStatistic, key) in developerStatistics">
                  <td>{{ developerStatistic.developer.transName }}</td>
                  <td>{{ developerStatistic.total }}</td>
                  <td>{{ developerStatistic.types['1'].count }}</td>
                  <td>{{ developerStatistic.types['3'].count }}</td>
                  <td>{{ developerStatistic.types['2'].count }}</td>
                  <td>{{ developerStatistic.types['4'].count }}</td>
                  <td>{{ developerStatistic.types['5'].count }}</td>
                  <td>{{ developerStatistic.statuses['2'].count }}</td>
                  <td>{{ developerStatistic.statuses['3'].count }}</td>
                  <td>{{ developerStatistic.statuses['4'].count }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>

  import Appeal from '@/model/appeal'
  import {mapMutations} from 'vuex'
  import { Trans } from "@/plugins/Translation"

  export default {
    data: () => ({
      years: [],
      types: [],
      statuses: [],
      year: null,
      monthStatistics: {},
      developerStatistics: [],
      yearActive: [],
      breadcrumbs: []
    }),
    metaInfo () {
      return {
        title: this.$i18n.t('AppealStatisticsTitleSEO'),
        meta: [{
          vmid: 'description',
          name: 'description',
          content: this.$i18n.t('AppealStatisticsDescriptionSEO'),
        }, {
          vmid: 'keywords',
          name: 'keywords',
          content: this.$i18n.t('AppealStatisticsKeywordsSEO'),
        }]
      }
    },
    created() {
      this.fetchData()
      this.scrollToTop()
    },
    methods: {
      ...mapMutations(['setLoading']),
      fetchData() {
        this.setLoading(true)
        Appeal.getAppealStatisticData().then((response) => {
          const data = response.data
          this.years = data.years
          this.year = data.year
          this.types = data.appealTypes
          this.statuses = data.appealStatuses
          this.breadcrumbs = [
            {text: this.$i18n.t('Главная'), disabled: false, href: Trans.currentLocaleUrl + '/'},
            {text: this.$i18n.t('Статистика по обращениям граждан и организаций на Портал проектов НПА'), disabled: true}
          ]
          this.setLoading(false)
          this.statisticAppeal(this.year)
        })
          .catch((error) => {
            this.setLoading(false)
            console.log(error)
          })
      },
      // статистика по году
      statisticAppeal(year) {
        this.setLoading(true)
        Appeal.getAppealStatistic(year)
          .then((response) => {
            const data = response.data
            this.yearActive = []
            this.yearActive[year] = true
            const ordered = {};
            Object.keys(data.monthStatistic).sort()
              .forEach(function (key) {
                ordered[key] = data.monthStatistic[key];
              })
            this.monthStatistics = ordered
            this.developerStatistics = data.developerStatistic
          })
          .catch((error) => {
            console.log(error)
          })

        this.setLoading(false)
      },
      // Прокручивание к началу страницы
      scrollToTop() {
        window.scrollTo(0, 0)
      }
    }
  }
</script>
